var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ml-3 mr-4",attrs:{"elevation":"1","fab":"","small":""},on:{"click":function($event){_vm.mini = !_vm.mini}}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.mini ? "mdi-format-list-bulleted" : "mdi-dots-vertical")+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }